import { TypographyProps } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid-premium'
import { BaseColumnConfig } from '../types'
import { baseColumnConfig } from './baseColumnConfig'
import { TextCell } from './TextCell'
import type { GridValidRowModel } from '@mui/x-data-grid/models/gridRows'

export type TextColumnConfig<T extends GridValidRowModel> = BaseColumnConfig<T, 'text'> & {
  columnType: 'text'
  appendText?: string
  textVariant?: TypographyProps['variant']
  color?: TypographyProps['color']
  filterOperators?: GridColDef<T>['filterOperators']
  groupingValueGetter?: GridColDef<T>['groupingValueGetter']
  editable?: boolean
  /** Wraps cell text onto multiple lines instead of truncating. Pair with `getRowHeight={() => 'auto'}` on the DataGrid. */
  wrapText?: boolean
}

const wrapTextStyle = {
  whiteSpace: 'normal',
  overflow: 'visible',
  textOverflow: 'clip',
  wordBreak: 'break-word',
} as const

export const getTextColumn = <T extends GridValidRowModel>({
  style,
  wrapText,
  ...config
}: TextColumnConfig<T>): GridColDef<T> => ({
  ...baseColumnConfig,
  ...style,
  ...config,
  groupingValueGetter: config.groupingValueGetter ?? config.valueGetter,
  renderCell: (params) => (
    <TextCell
      dataTestId={config.getDataTestId ? config.getDataTestId(params) : undefined}
      variant={config.textVariant}
      color={config.color}
      {...(wrapText ? { style: wrapTextStyle } : {})}
    >
      {params.formattedValue}
      {params.formattedValue && config.appendText ? config.appendText : ''}
    </TextCell>
  ),
})
